export default __webpack_public_path__ + "static/media/ReadmeGeneratorDemo.00434625.gif";